/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var NCHAT_CHANNEL_TIMEOUT_MS = 3 * 1000;
var MAX_CONNECT_RETRY_TIMEOUT_MS = 30 * 1000;
var N_CHAT_CHANNEL = 'nchat:channel';
var SOCKET_EVENT = {
    CONNECT: 'connect',
    CONNECT_ERROR: 'connect_error',
    SEND: 'send',
    DISCONNECT: 'disconnect',
};
var SessionIOError = /** @class */ (function (_super) {
    __extends(SessionIOError, _super);
    function SessionIOError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SessionIOError;
}(Error));
var TimeoutNatChannelError = /** @class */ (function (_super) {
    __extends(TimeoutNatChannelError, _super);
    function TimeoutNatChannelError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'TimeoutNatChannelError';
        _this.message = 'nchat:channel 응답에서 timeout이 발생했습니다.';
        return _this;
    }
    return TimeoutNatChannelError;
}(SessionIOError));
var UnexpectedSessionIOError = /** @class */ (function (_super) {
    __extends(UnexpectedSessionIOError, _super);
    function UnexpectedSessionIOError(errorMessage) {
        var _this = _super.call(this) || this;
        _this.name = 'UnexpectedSessionIOError';
        _this.message = errorMessage;
        return _this;
    }
    return UnexpectedSessionIOError;
}(SessionIOError));
var ChannelName = 'update-result';
var LogKey = {
    // sessionIo log key
    SessionIOInitialized: 'SessionIOInitialized',
    SessionIOResponse: 'SessionIOResponse',
    SessionIODisconnected: 'SessionIODisconnected',
    SessionIOTaskTimeout: 'SessionIOTaskTimeout',
    SessionIOTaskSubscribeResponse: 'SessionIOTaskSubscribeResponse',
    SessionIOSubscribeResponse: 'SessionIOSubscribeResponse',
    SessionIOTaskListenerInfo: 'SessionIOTaskListenerInfo',
    SessionIORetry: 'SessionIORetry',
    // mydata updater log key
    MydataUpdaterTaskList: 'MydataUpdaterTaskList', // 요청한 task list
    MydataUpdaterTaskResponseList: 'MydataUpdaterTaskResponseList', // sessionIo로 요청을 하기 전에, taskUpdate Fetch 결과
    MydataUpdaterTaskResponseInfo: 'MydataUpdaterTaskRequestInfo', // sessionIO 결과 list (success, failure)
    MydataUpdaterResponseError: 'MydataUpdaterResponseError', // sessionIO 에러
};

export { ChannelName as C, LogKey as L, MAX_CONNECT_RETRY_TIMEOUT_MS as M, NCHAT_CHANNEL_TIMEOUT_MS as N, SOCKET_EVENT as S, TimeoutNatChannelError as T, UnexpectedSessionIOError as U, __spreadArray as _, __extends as a, __awaiter as b, __generator as c, __assign as d, N_CHAT_CHANNEL as e, SessionIOError as f };
